<!-- maintenance.component.html -->

<div class="maintenance-container">
  <div class="maintenance-message">
    <img src="assets/images/maintenance.jpg" alt="Maintenance Icon">
    <h1>We're Under Maintenance</h1>
    <p>Sorry for the inconvenience. We're currently upgrading our website to serve you better.</p>
  </div>
  <div class="animation">
    <!-- Insert your cool animation here -->
    <!-- Example: -->
    <div class="spinner"></div>
  </div>
</div>
